import { useMemo } from 'react'
import { HeaderContext } from '@tanstack/react-table'
import clsx from 'clsx'

import { Log } from '@/types/logs'
import { Button } from '@/ui/Button'
import { checkIsLogUnfinished } from '../../helpers/checkIsLogUnfinished'
import styles from './UnfinishedHeader.module.scss'

import ArrowDownIcon from '../../assets/arrow-down.svg'

export const UnfinishedHeader = ({ table, column }: HeaderContext<Log, unknown>) => {
    const amountOfUnfinishedLogs = useMemo(
        () => table.getFilteredRowModel().rows.filter((row) => checkIsLogUnfinished(row.original)).length,
        [table.getFilteredRowModel().rows]
    )
    const state = table.getState()

    const isActive = useMemo(() => state.sorting.find((item) => item.id === 'unfinished'), [state])

    const handleSortColumn = () => {
        column.toggleSorting(false)
    }

    return (
        <Button
            size="small"
            variant="transparent"
            onClick={handleSortColumn}
            className={clsx(styles.trigger, { [styles.active]: isActive })}
        >
            <strong>{amountOfUnfinishedLogs}</strong>
            <span>unfinished</span>
            <ArrowDownIcon />
        </Button>
    )
}
